import QuestionsBreakdownReport from '../../../assignments/pages/ManageAssign/components/Reports/QuestionsBreakdownReport';
import { useGetSelfStudyCumulativeReportMutation } from '../../../../features/authentication/reportApiSlice';
import { useLocation } from 'react-router';

const SelfStudyCumulativeReport = () => {
  const location = useLocation();
  const selfStudyFilters = location.state?.filters || {};
  const [getSelfStudyCumulativeReport] = useGetSelfStudyCumulativeReportMutation();

  var headerOptions = {
    reportTitle: selfStudyFilters?.studentName ? 'Individual Cumulative Report' : 'Cumulative Self Study Report',
    showClassDropdown: false,
    showTeacherName: true,
    showStudentName: !!selfStudyFilters?.studentName,
    showClassName:  !!selfStudyFilters.classHeader,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: true,
    showReportType: false,
    reportType: 'Assignment',
    isAssessment: false,
    isSelfStudyCumulative: true,
    hideIndividualResults: true
  };

  return (
    <QuestionsBreakdownReport
      isRetakeReport={false}
      exportFileName='CumulativeSelfStudyReport'
      reportDataEndpoint={getSelfStudyCumulativeReport}
      isTeacherReport={true}
      headerOptions={headerOptions}
      studentToIncludeTab={2}
      goBackOnError={true}
      initialClassId={-1}
    />
  );

};

export default SelfStudyCumulativeReport;